import { useApi, apiResolver } from "@/api/useApi";
import { useMemo } from "react";

type TicketValidation = {
  ticketId: string;
  isValidated: boolean;
};

type GetTicketValidationRequest = {
  ticketId: string;
};

type UpdateTicketValidationRequest = {
  ticketId: string;
  isValidated: boolean;
};

export const useTicketValidationApi = () => {
  const { api } = useApi();

  return useMemo(
    () => ({
      getTicketValidation: ({ ticketId }: GetTicketValidationRequest) =>
        apiResolver<TicketValidation>(
          api.get(`/platform/ticket-validation/${ticketId}`)
        ),
      updateTicketValidation: ({
        ticketId,
        isValidated,
      }: UpdateTicketValidationRequest) =>
        apiResolver<TicketValidation>(
          api.put(`/platform/ticket-validation/${ticketId}`, { isValidated })
        ),
    }),
    [api]
  );
};
